import { AgentRole } from '@urbanx/agx.auth.client';

export const AgentRoleOptions = Object.entries(AgentRole).map(([key, value]) => ({
  value,
  label: key.replace(/([a-z])([A-Z])/g, '$1 $2'),
}));
